var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenericSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#455063;}.cls-3{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.78,
    y: 63.89,
    width: 566.45,
    height: 472.22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "cls-2",
    d: "M496.72,238.42H171.18a8.33,8.33,0,0,0,0,16.66H496.72a68.74,68.74,0,0,1,0,137.47h-42.9a8.33,8.33,0,1,0,0,16.66h42.9a85.39,85.39,0,1,0,0-170.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    className: "cls-2",
    d: "M158.69,340.18a16.39,16.39,0,1,0-16.4-16.39v0A16.4,16.4,0,0,0,158.69,340.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-2",
    d: "M277.94,323.81a30.47,30.47,0,1,0-30.47,30.47h0A30.51,30.51,0,0,0,277.94,323.81Zm-44.28,0a13.81,13.81,0,1,1,13.81,13.81h0A13.83,13.83,0,0,1,233.66,323.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-2",
    d: "M366.71,323.81a30.48,30.48,0,1,0-30.47,30.47A30.47,30.47,0,0,0,366.71,323.81Zm-44.29,0a13.82,13.82,0,1,1,13.82,13.81h0A13.83,13.83,0,0,1,322.42,323.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-2",
    d: "M455.49,323.81A30.47,30.47,0,1,0,425,354.28,30.47,30.47,0,0,0,455.49,323.81Zm-44.28,0A13.81,13.81,0,1,1,425,337.62,13.81,13.81,0,0,1,411.21,323.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    className: "cls-2",
    d: "M447.33,462.74h-78V409.21H420.5a8.33,8.33,0,0,0,0-16.66H101a68.74,68.74,0,0,1,0-137.48h36.8a8.33,8.33,0,0,0,0-16.66H101a85.4,85.4,0,0,0,0,170.8H228.49v53.54h-78a36.57,36.57,0,0,0,0,73.13h69.7a8.33,8.33,0,1,0,0-16.66h-69.7a19.91,19.91,0,0,1,0-39.82H447.33a19.91,19.91,0,0,1,0,39.82H253.47a8.33,8.33,0,0,0,0,16.66H447.33a36.57,36.57,0,0,0,0-73.13Zm-202.19,0V409.21H352.63v53.54Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    className: "cls-2",
    d: "M216.23,106.74a148.2,148.2,0,0,1,165.31,0,8.32,8.32,0,0,0,9.18-13.89h0a164.94,164.94,0,0,0-183.7,0,8.32,8.32,0,0,0-2.35,11.54h0a8.32,8.32,0,0,0,11.54,2.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    className: "cls-2",
    d: "M355.16,150.07a8.33,8.33,0,0,0,4.52-15.32,111.25,111.25,0,0,0-121.62,0,8.33,8.33,0,1,0,8.43,14.37c.2-.12.39-.25.58-.38a94.61,94.61,0,0,1,103.54,0,8.28,8.28,0,0,0,4.5,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "cls-2",
    d: "M298.9,168.78a47.75,47.75,0,0,0-28.84,10,8.33,8.33,0,0,0,10,13.33,29.81,29.81,0,0,1,37.62,0,8.33,8.33,0,1,0,10-13.33,47.75,47.75,0,0,0-28.84-10Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericSymbol);
export default __webpack_public_path__ + "static/media/generic-symbol.713e195ffec54f7c055ee1f0e9db8aa6.svg";
export { ForwardRef as ReactComponent };